<template>
  <app-layout>
    <jet-dialog-modal maxWidth="2xl" :show="showEditModal === true" @close="showEditModal = false">
      <template #content>

        <edit-room-form @updating="updatingRoom" @updated="updatedRoom" :room-name="roomName"
                        :id="roomId"></edit-room-form>
      </template>

      <template #footer>
        <div class="text-md text-blue-500 font-bold inline-block ml-1">
          agilesuite.io
        </div>
      </template>
    </jet-dialog-modal>

    <div
        v-if="!gameLoading && moderator ==='no'"
        class="text-center font-bold bg-yellow-100 border-yellow-500 text-orange-700 p-4"
        role="alert"
    >
      <p>Your room is missing a moderator, please assign someone to it.</p>
    </div>

    <Lobby :room="room">

      <template #logo>
        <img src="/images/poker.svg" class="h-12 w-12"/>
      </template>
      <template #custom>

        <div class="flex flex-col">
          <div class="flex justify-center">

            <button
                @click="showEditModal = true"
                class="
                  focus:outline-none
                  text-base
                  mr-2
                  bg-gray
                  hover:bg-blue-100
                  text-blue-500
                  border-2
                  py-1
                  px-2
                  border-blue-500
                  font-bold
                  rounded
                "
            >
              <CogIcon class="w-5 h-5 flex-shrink-0 text-black"></CogIcon>
            </button>


            <button
                @click="info(roomKey)"
                class="
                  focus:outline-none
                  text-base

                  bg-gray
                  hover:bg-blue-100
                  text-blue-500
                  border-2
                  py-1
                  px-2
                  border-blue-500
                  font-bold
                  rounded
                "
            >
              <LinkIcon class="w-5 h-5 flex-shrink-0 text-black"></LinkIcon>
            </button>
            <input
                type="hidden"
                :id="'room' + roomKey"
                :value="getLink(roomKey)"
            />

          </div>


          <div class=" flex justify-center">

            <div class="w-40 text-lg font-bold pt-2">

              <label>Moderator: </label>
              <a-select
                  v-model:value="moderator"
                  ref="select"
                  class="block shadow w-full"
                  @change="changeModerator($event)"
              >
                <a-select-option v-for="player in players" :value="player.id"
                >{{ player.name }}
                </a-select-option>
                <a-select-option value="no">No moderator</a-select-option>
              </a-select>

            </div>

          </div>
        </div>
      </template>


      <template #players>
        <div class="relative" v-for="player in players">
          <div class="px-2">
            <div>
              <label class="text-xl font-bold"
              > {{ player.name }}</label>
            </div>
            <label v-html="player.avatar" class="text-2xl block"></label>
          </div>
        </div>
      </template>
      <template #room>


        <jet-dialog-modal maxWidth="2xl" :show="showLucky === true" @close="showLucky = false">

          <template #title>

            <div class="font-bold text-lg ">
              Lucky Pick

            </div>
          </template>
          <template #content>

            <div>
              <lucky-shuffle :cards="players"></lucky-shuffle>
            </div>

          </template>

          <template #footer>
            <div class="text-md text-blue-500 font-bold inline-block ml-1">
              agilesuite.io
            </div>
          </template>
        </jet-dialog-modal>


        <a-spin :spinning="gameLoading" style="z-index: 9999;" size="large" tip="🔥 Ready...Go!">
          <!--          <v-tour name="myTour" :steps="steps" :callbacks="myCallbacks"></v-tour>-->

          <div
              :style="toured ? ' min-height: calc(100vh + 20rem);': ''"

              @mouseover="isCardFocused = true"
              @mouseout="isCardFocused = false"
          >
            <div class="px-10 py-6">
              <div class="flex justify-between mx-auto sm:px-6 lg:px-8">
                <div
                    class="font-black text-black text-4xl self-start"
                >
                  <div class="inline-block room-details-area mr-2">
                    #{{ roomName }}
                  </div>

                  <button
                      @click="showEditModal = true"
                      class="
                  focus:outline-none
                  text-base
                  mr-2
                  bg-gray
                  hover:bg-blue-100
                  text-blue-500
                  border-2
                  py-1
                  px-2
                  border-blue-500
                  font-bold
                  rounded
                "
                  >
                    <CogIcon class="w-5 h-5 flex-shrink-0 text-black"></CogIcon>
                  </button>


                  <button
                      @click="info(roomKey)"
                      class="
                  focus:outline-none
                  text-base

                  bg-gray
                  hover:bg-blue-100
                  text-blue-500
                  border-2
                  py-1
                  px-2
                  border-blue-500
                  font-bold
                  rounded
                "
                  >
                    <LinkIcon class="w-5 h-5 flex-shrink-0 text-black"></LinkIcon>
                  </button>


                  <button
                      @click="showLucky = true;"
                      class="
                    ml-2
                    hover:cursor-pointer
                            font-bold
                "
                  >
                    <label class="     hover:cursor-pointer text-orange-400 text-base"> Lucky Pick</label>
                  </button>


                  <input
                      type="hidden"
                      :id="'room' + roomKey"
                      :value="getLink(roomKey)"
                  />
                </div>


                <div class="moderator-area font-black text-black text-lg self-end">

                  <div>
                    <label>Moderator: </label>
                    <a-select
                        v-model:value="moderator"
                        ref="select"
                        class="block shadow w-full"
                        @change="changeModerator($event)"
                    >
                      <a-select-option v-for="player in players" :value="player.id"
                      >{{ player.name }}
                      </a-select-option>
                      <a-select-option value="no">No moderator</a-select-option>
                    </a-select>
                  </div>

                  <div v-if="moderator == $page.props.user.id ">
                    <label>Show Cards: </label>
                    <a-tooltip>
                      <template #title>
                        You could use this button to hide cards during screen sharing. You can open 2nd browser to vote
                        and use this screen for sharing purpose.
                      </template>
                      <a-switch v-model:checked="showCards"/>
                    </a-tooltip>
                  </div>
                </div>
              </div>
            </div>
            <template v-if="moderator == $page.props.user.id ">
              <div class="flex justify-center">
                <input v-model="topic" type="text"
                       class=" w-60  z-0 shadow rounded-lg border-none focus:border-none focus:outline-none"
                       placeholder="Enter Your Topic (Optional)">

                <button
                    class="ml-2 h-10 py-1 w-15 px-2 shadow mr-2 rounded-lg text-white bg-blue-500 hover:bg-blue-600 font-bold"
                    @click="updateTopic">Save
                </button>
              </div>
            </template>
            <template v-if="moderator != $page.props.user.id && topic">

              <div class="relative">
                <label class="flex justify-center rounded-lg text-2xl text-blue-400 font-bold z-0 ">
                  Topic: {{ topic }}
                </label>
              </div>
            </template>
            <div class="game-panel-area px-10 py-6" v-if="$page.props.user">

              <div class="flex justify-center">


                <div
                    v-if="roomStateFinished && !gameLoading && timerCount === 0"
                    class="
                bg-clip-content
                p-6
                bg-transparent
                border-4 border-indigo-300 border-dashed
              "
                >
                  <!--                  <div class="text-center relative">-->
                  <!--                    <button-->
                  <!--                        class="-->
                  <!--                focus:outline-none-->
                  <!--                    mb-2-->
                  <!--                    bg-gray-500-->
                  <!--                    hover:bg-gray-200-->
                  <!--                   text-white-->
                  <!--                    font-bold-->
                  <!--                    py-2-->
                  <!--                    px-4-->
                  <!--                    rounded-->
                  <!--                   hover:text-gray-500-->
                  <!--                  "-->
                  <!--                        @click="showHideResult = !showHideResult"-->
                  <!--                    >-->
                  <!--                      {{ showHideResult ? 'Show' : 'Hide' }} Result-->
                  <!--                    </button>-->
                  <!--                  </div>-->


                  <div
                      v-if="moderator === $page.props.user.id || moderator === 'no'"
                      class="text-center relative"
                  >

                    <button
                        class="
                focus:outline-none

                    bg-blue-500
                    hover:bg-blue-200
                   text-white
                    font-bold
                    py-2
                    px-4
                    rounded
                   hover:text-blue-500
                  "
                        @click="announceNewGame()"
                    >
                      Start New Voting
                    </button>
                  </div>
                  <div v-else>
                    <div class="font-semibold block text-center text-lg">
                      Waiting for a new game... 👀
                    </div>
                  </div>
                </div>

                <div class="relative flex justify-center items-center">
                  <div
                      class="font-black text-black text-4xl inline-block"
                      v-if="timerCount > 0"
                  >
                    {{ timerCount }}
                  </div>
                </div>
                <div
                    v-if="!roomStateFinished && !gameLoading && timerCount === 0"
                    class="h-full block text-center text-lg"
                >
                  <div v-if="!selectedCard">
                    <div
                        class="
                    font-semibold
                    bg-clip-content
                    p-6
                    bg-transparent
                    border-4 border-indigo-300 border-dashed
                  "
                    >

                      <div>Please select a card 🥺</div>
                      <div class="flex space-x-2 flex-between">
                        <button
                            v-if="
                      moderator === $page.props.user.id || moderator === 'no'
                    "
                            class="
                      focus:outline-none
                      mt-3
                      bg-gray-500
                      hover:bg-gray-200
                      text-white
                      font-bold
                      py-2
                      px-4
                      rounded
                      hover:text-blue-500
                    "
                            @click="restart()"
                        >
                          Restart
                        </button>
                        <button
                            v-if="moderator === $page.props.user.id || moderator === 'no'"
                            class="
                    focus:outline-none
                    mt-3
                    bg-blue-500
                    hover:bg-blue-200
                   text-white
                    font-bold
                    py-2
                    px-4
                    rounded
                   hover:text-blue-500
                  "
                            @click="showResult()"
                        >
                          Show Cards
                        </button>
                      </div>

                    </div>
                  </div>
                  <div
                      v-else
                      class="
                  font-semibold
                  bg-clip-content
                  p-6
                  bg-transparent
                  border-4 border-indigo-300 border-dashed
                "
                  >
                    <div>Voting in progress 🔥</div>
                    <button
                        v-if="moderator === $page.props.user.id || moderator === 'no'"
                        class="
                    focus:outline-none
                    mt-3
                    bg-blue-500
                    hover:bg-blue-200
                    text-white
                    font-bold
                    py-2
                    px-4
                    rounded
                    hover:text-blue-500
                  "
                        @click="showResult()"
                    >
                      Show Cards
                    </button>

                  </div>
                </div>


              </div>
            </div>

            <div
                class="flex justify-center px-20"

            >
              <ul
                  class="
              w-3/5
              flex
              content-center
              flex-row flex-wrap
              justify-center
              space-x-10
            "
              >
                <li v-for="(player, index) in players">
                  <player-card
                      :key="player.id"
                      :resultTier="
                      player.result === summary.lowest_vote ?  -1 : player.result === summary.highest_vote
                    ? 1 : 0
                "
                      :player="player"
                      :roomStateFinished="roomStateFinished"
                      :timerCount="timerCount"
                      class="mt-4"
                  />
                </li>
              </ul>
            </div>

            <div class="playing-area bg-gray-100 lg:fixed bottom-0 w-full">
              <div class="justify-center">
                <transition name="fade" mode="out-in">
                  <div class="text-center" v-if="!roomStateFinished">
                    <a-tooltip>
                      <template #title>
                        Free credits means how many games you are allowed to play. Please upgrade your account to
                        unblock limits.
                      </template>
                      <div v-if="is_room_subscribed === false" class="cursor-pointer text-red-400 font-bold text-md">
                        Free
                        Credits: {{
                          play_count
                        }}/{{ play_max_count }}
                      </div>
                    </a-tooltip>

                    <div v-if="showCards">
                      <div>{{ errorMessage }}</div>
                      <div class="p-4 space-x-4">
                        <poker-card
                            v-for="item in votingSystem"
                            :key="item.toString()"
                            :number="item.toString()"
                            :value.sync="item === selectedCard"
                            @click="selectNumberByItem(item)"
                        />
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <hr class="mt-1"/>
                    <div
                        :style="{'display':showHideResult ? 'none': 'block'}"

                        class="
                    flex-1
                    rounded-md
                    bg-fuchsia-500
                    text-white
                    font-semibold
                    flex
                    items-center
                    justify-center
                  "
                    >
                      <div class="max-w-7xl w-full mx-auto py-6 sm:px-6 lg:px-8 max-h-72 overflow-y-auto	">
                        <div
                            class="
                        flex flex-col
                        lg:flex-row
                        w-full
                        lg:space-x-2
                        space-y-2
                        lg:space-y-0
                        mb-2
                        lg:mb-4
                      "
                        >
                          <div class="w-full">
                            <div
                                class="widget w-full p-3 rounded-lg bg-transparent"
                            >
                              <div
                                  class="flex flex-row items-center justify-between"
                              >
                                <div class="flex flex-col">
                                  <div
                                      class="text-sm uppercase font-black text-black"
                                  >
                                    ?
                                  </div>

                                  <div class="flex-shrink-0 group block">
                                    <div
                                        class="flex items-center py-2"
                                        v-for="item in players.filter(
                                    (player, index) => player.result === '?'
                                  )"
                                    >
                                      <div>
                                        <!--                                <img class="inline-block h-6 w-6 rounded-full"-->
                                        <!--                                     :src="item.avatar"-->
                                        <!--                                     alt=""/>-->
                                        <div v-if="item.photo && !item.photo.includes('avatar.png')">
                                          <img class="h-6" :src="item.photo"/>
                                        </div>
                                        <div v-else>
                                          <label v-html="item.avatar" class="text-2xl block mr-1"></label>
                                        </div>
                                      </div>
                                      <div class="ml-3">
                                        <p
                                            class="
                                        text-sm
                                        font-medium font-medium
                                        text-black
                                      "
                                        >
                                          {{ item.name }}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="w-full">
                            <div
                                class="widget w-full p-3 rounded-lg bg-transparent"
                            >
                              <div
                                  class="flex flex-row items-center justify-between"
                              >
                                <div class="flex flex-col">
                                  <div
                                      class="text-sm uppercase font-black text-black"
                                  >
                                    ∞
                                  </div>

                                  <div class="flex-shrink-0 group block">
                                    <div
                                        class="flex items-center py-2"
                                        v-for="item in players.filter(
                                    (player, index) => player.result === '∞'
                                  )"
                                    >
                                      <div>
                                        <!--                                <img class="inline-block h-6 w-6 rounded-full"-->
                                        <!--                                     :src="item.avatar"-->
                                        <!--                                     alt=""/>-->
                                        <div v-if="item.photo && !item.photo.includes('avatar.png')">
                                          <img class="h-6" :src="item.photo"/>
                                        </div>
                                        <div v-else>
                                          <label v-html="item.avatar" class="text-2xl block mr-1"></label>
                                        </div>
                                      </div>
                                      <div class="ml-3">
                                        <p
                                            class="
                                        text-sm
                                        font-medium font-medium
                                        text-black
                                      "
                                        >
                                          {{ item.name }}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="w-full">
                            <div
                                class="widget w-full p-4 rounded-lg bg-transparent"
                            >
                              <div
                                  class="flex flex-row items-center justify-between"
                              >
                                <div class="flex flex-col">
                                  <div
                                      class="text-sm uppercase font-black text-black"
                                  >
                                    Highest
                                  </div>

                                  <div class="flex-shrink-0 group block">
                                    <div
                                        class="
                                    text-xl
                                    font-bold
                                    text-black text-center
                                    mt-2
                                  "
                                    >
                                      {{ summary.highest_vote }}
                                    </div>
                                    <div
                                        class="flex items-center py-2"
                                        v-for="item in players.filter(
                                    (player, index) => {
                                      return player.result === null
                                        ? false
                                        : player.result ===
                                            summary.highest_vote;
                                    }
                                  )"
                                    >
                                      <div>
                                        <!--                                <img class="inline-block h-6 w-6 rounded-full"-->
                                        <!--                                     :src="item.avatar"-->
                                        <!--                                     alt=""/>-->
                                        <div v-if="item.photo && !item.photo.includes('avatar.png')">
                                          <img class="h-6" :src="item.photo"/>
                                        </div>
                                        <div v-else>
                                          <label v-html="item.avatar" class="text-2xl block mr-1"></label>
                                        </div>
                                      </div>
                                      <div class="ml-3">
                                        <p
                                            class="
                                        text-sm
                                        font-medium font-medium
                                        text-black
                                      "
                                        >
                                          {{ item.name }}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="w-full">
                            <div
                                class="widget w-full p-4 rounded-lg bg-transparent"
                            >
                              <div
                                  class="flex flex-row items-center justify-between"
                              >
                                <div class="flex flex-col">
                                  <div
                                      class="text-sm uppercase font-black text-black"
                                  >
                                    Lowest
                                  </div>

                                  <div class="flex-shrink-0 group block">
                                    <div
                                        class="
                                    text-xl
                                    font-bold
                                    text-black text-center
                                    mt-2
                                  "
                                    >
                                      {{ summary.lowest_vote }}
                                    </div>

                                    <div
                                        class="flex items-center py-2"
                                        v-for="item in players.filter(
                                    (player, index) => {
                                      return player.result === null
                                        ? false
                                        : player.result === summary.lowest_vote;
                                    }
                                  )"
                                    >
                                      <div>
                                        <!--                                <img class="inline-block h-6 w-6 rounded-full"-->
                                        <!--                                     :src="item.avatar"-->
                                        <!--                                     alt=""/>-->
                                        <div v-if="item.photo && !item.photo.includes('avatar.png')">
                                          <img class="h-6" :src="item.photo"/>
                                        </div>
                                        <div v-else>
                                          <label v-html="item.avatar" class="text-2xl block mr-1"></label>
                                        </div>
                                      </div>
                                      <div class="ml-3">
                                        <p
                                            class="
                                        text-sm
                                        font-medium font-medium
                                        text-black
                                      "
                                        >
                                          {{ item.name }}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!--                      <div class="w-full">-->
                          <!--                        <div-->
                          <!--                            class="widget w-full p-4 rounded-lg bg-transparent"-->
                          <!--                        >-->
                          <!--                          <div-->
                          <!--                              class="flex flex-row items-center justify-between"-->
                          <!--                          >-->
                          <!--                            <div class="flex flex-col">-->
                          <!--                              <div-->
                          <!--                                  class="text-sm uppercase font-black text-black"-->
                          <!--                              >-->
                          <!--                                Average-->
                          <!--                              </div>-->
                          <!--                              <div-->
                          <!--                                  class="-->
                          <!--                                  text-xl-->
                          <!--                                  font-bold-->
                          <!--                                  text-black text-center-->
                          <!--                                  mt-2-->
                          <!--                                "-->
                          <!--                              >-->
                          <!--                                {{ summary.average }}-->
                          <!--                              </div>-->
                          <!--                            </div>-->
                          <!--                          </div>-->
                          <!--                        </div>-->
                          <!--                      </div>-->

                          <div class="w-full">
                            <div
                                class="widget w-full p-4 rounded-lg bg-transparent"
                            >
                              <div
                                  class="flex flex-row items-center justify-between"
                              >
                                <div class="flex flex-col">
                                  <div
                                      class="text-sm uppercase font-black text-black"
                                  >
                                    TOTAL VOTES
                                  </div>
                                  <div
                                      class="
                                  text-xl
                                  font-bold
                                  text-black text-center
                                  mt-2
                                "
                                  >
                                    {{ summary.total_votes }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="w-full lg:w-1/4">
                            <div
                                class="widget w-full p-4 rounded-lg bg-transparent"
                            >
                              <div
                                  class="flex flex-row items-center justify-between"
                              >
                                <div class="flex flex-col">
                                  <div
                                      class="text-sm uppercase font-black text-black"
                                  >
                                    Agreement
                                  </div>
                                  <div
                                      class="
                                  text-xl
                                  font-bold
                                  text-black text-center
                                  mt-2
                                "
                                  >
                                    <agreement-bar
                                        :percent="summary.rate"
                                    ></agreement-bar>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </a-spin>
      </template>
    </Lobby>
  </app-layout>
</template>

<style scoped>
/*.PokerRoom {*/
/*  min-height: calc(100vh - 130px);*/
/*}*/
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.bg-white {
  display: none;
}

/*.PokerRoom__leftPlayerList {*/
/*  left: -107px;*/
/*  top: 0;*/
/*}*/

/*.PokerRoom__rightPlayerList {*/
/*  right: -88px;*/
/*  top: 0;*/
/*}*/
</style>


<script>
import AppLayout from "@/Layouts/AppLayout";
import Welcome from "@/Jetstream/Welcome";
import PlayerList from "../../Components/PlayerList/PlayerList";
import PokerCard from "../../Components/PokerCard/PokerCard";
import PlayerCard from "../../Components/PlayerCard/PlayerCard";
import {CogIcon, LinkIcon, QuestionMarkCircleIcon} from '@heroicons/vue/outline'
import _ from "lodash";
import AgreementBar from "@/Components/AgreementBar/AgreementBar";
import {message} from "ant-design-vue";
import DialogModal from "@/Jetstream/DialogModal";
import JetDialogModal from "@/Jetstream/DialogModal";
import CreateRoom from "@/Pages/PlanningPoker/CreateRoom";
import EditRoomForm from "@/Pages/PlanningPoker/EditRoomForm";
import Lobby from "@/Pages/Lobby/Lobby";
import WaitingList from "../Lobby/Components/WaitingList";
import emitter from 'tiny-emitter/instance'
import {Inertia} from '@inertiajs/inertia'
import {notification} from 'ant-design-vue';
import LuckyShuffle from "@/Pages/LuckyShuffle/LuckyShuffle";

export default {
  components: {
    LuckyShuffle,
    Inertia,
    emitter,
    WaitingList,
    Lobby,
    QuestionMarkCircleIcon,
    LinkIcon,
    EditRoomForm,
    CreateRoom,
    JetDialogModal,
    DialogModal,
    CogIcon,
    AgreementBar,
    AppLayout,
    Welcome,
    PlayerList,
    PokerCard,
    PlayerCard,
  },

  props: ["roomId", "room"],
  data() {
    return {
      showLucky: false,
      steps: [
        {
          target: '.game-panel-area',  // We're using document.querySelector() under the hood
          content: 'Game control panel',
          header: {
            title: '(1/4)',
          },
        },
        {
          target: '.room-details-area',
          content: `Click icon to configure room or share link with others.`,
          header: {
            title: '(2/4)',
          },
        },
        {
          target: '.moderator-area',
          content: 'Change moderator who can control the game, if no one selected, every one can control your game progress.',
          params: {
            placement: 'bottom'
          },
          header: {
            title: '(3/4)',
          },
        },
        {
          target: '.playing-area',
          content: 'Pick Card or Check Result.',
          header: {
            title: '(4/4)',
          },
        },
      ],
      echo: window.Echo,
      showHideResult: false,
      errorMessage: 'Pick up a card here 👇',
      moderator: null,
      questions: 0,
      breakDowns: 0,
      showCards: true,
      roomKey: null,
      myCallbacks: {
        onSkip: () => {
          this.toured = true;
        },
        onFinish: () => {
          this.toured = true;
        }
      },
      roomName: null,
      timerCount: 0,
      pokeCardState: {},
      showEditModal: false,
      isCardFocused: false,
      roomStateFinished: false,
      votingSystem: [],
      players: [],
      play_count: '',
      is_room_subscribed: null,
      play_max_count: '',
      localWebsocket: null,
      user_results: [],
      userResult: null,
      summary: {},
      topic: null,
      isCounterFinished: true,
      gameLoading: false,
      selectedCard: null,
      toured: true,
    };
  },
  unmounted() {
    Echo.leave("planning-poker-room." + this.roomId)
    console.log('unmounted')
  },
  beforeMount() {
    this.currentUser = this.$page.props.user;
  },
  mounted() {
    if (this.$page.props.user) {
      this.gameLoading = true;
      console.log('connect')
      Echo.join("planning-poker-room." + this.roomId)
          .listen("PlanningPokerModeratorChangedEvent", (e) => {
            this.moderator = e.moderator ?? 'no';
            message.success("Moderator has been changed.");
          })
          .listen('LobbyEvent', (e) => {
            emitter.emit('VueLobbyEvent', e);
            if (e.approvedUserId === this.$page.props.user.id) {
              location.reload();
            }
          })
          .listen('TopicUpdateEvent', (e) => {
            notification['warning']({
              message: 'Topic is updated',
              description: e.result,
            });
            this.topic = e.result;
          })
          .listen("PointUpdateEvent", (e) => {
            // we don't update the curreny user result to avoid the async issue
            if (e.userId === this.$page.props.user.id && !this.isCardFocused) {
              this.selectedCard = e.result;
            }
            this.updatePoint(e.userId, e.result);
          })
          .listen("FinishGameEvent", (e) => {
            this.getResult();
          })
          .listen("StartNewGameEvent", (e) => {
            this.startNewGame();
          })
          .here((users) => {
            this.players = users.map((user, index) => {
              // get current player
              return this.userTransFormer(user);
            });
            this.jonRoom();
          })
          .joining((user) => {
            this.players.push(this.userTransFormer(user));
            this.jonRoom();
          })
          .leaving((user) => {
            this.players.splice(
                this.players.findIndex(function (i) {
                  return i.id === user.original.id;
                }),
                1
            );
          })
          .error((error) => {
            console.error(error);
          });
    }
  },
  created() {
  },
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
          }, 750);
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },
  computed: {
    degree() {
      return this.players?.length ? 360 / this.players?.length : 45;
    },
  },
  methods: {
    updateTopic() {
      let app = this;
      app.gameLoading = true;
      axios
          .post(route("planning-rooms.updateTopic", {id: app.roomId}), {
            topic: app.topic,
          })
          .then((response) => {
            app.gameLoading = false;
            if (!response.data.success) {
              message.error(response.data.message, 5);
            } else {
              message.success('Successfully updated', 5);
            }
          })
          .catch((error) => {
            app.gameLoading = false;
            console.log(error);
            message.error('Cannot update topic', 5);
          });
    },
    roomUpdated() {

    },
    changeModerator(value) {
      let app = this;
      axios
          .post(route("planning-rooms.changeModerator", {id: app.roomId}), {
            moderator: value === "no" ? null : value,
          })
          .then((response) => {
            // app.moderator = value;
          })
          .catch((error) => {
            //console.log(error);
          });
    },
    assignResult: _.debounce(function () {
      let app = this;
      let number = app.selectedCard ? app.selectedCard : null;
      this.updatePoint(app.$page.props.user.id, number);
      axios
          .post(route("planning-rooms.assignResult", {id: app.roomId}), {
            point: number,
          })
          .then((response) => {
            // app.updatePoint(app.$page.props.user.id, number);
          })
          .catch((error) => {
            //console.log(error);
          });
    }, 350),
    updatePoint(userId, point) {
      const targetPlayer = this.players.find((player) => player.id === userId);
      targetPlayer.result = point;
    },
    enteredInCheck() {
      if (window.localStorage.getItem('toured') != 1) {
        this.$tours['myTour'].start()
        this.touredDone();
      } else {
        this.toured = true;
      }
    },
    jonRoom() {
      let app = this;
      axios
          .post(route("planning-rooms.joinRoom", {id: app.roomId}), {})
          .then((response) => {
            const data = response.data.data;
            app.gameLoading = false;
            if (response.data.success === true) {
              app.roomKey = data.room_key;
              app.roomStateFinished = data.is_finished;
              app.roomName = data.room_name;
              window.document.title = app.roomName + ' | AgileSuite.io';
              app.user_results = data.room_result.user_results;
              app.play_count = data.play_count;
              app.play_max_count = data.play_max_count;
              app.is_room_subscribed = data.is_room_subscribed;
              app.topic = data.topic;
              app.summary = data.room_result.summary;
              app.moderator = data.room_moderator ? this.players.find((player) => player.id === data.room_moderator) !== undefined ? data.room_moderator : "no" : "no";

              if (app.players.length > data.limit_users) {
                console.log(app.players);
                app.errorMessage = 'Your room has just reached max players, please upgrade your plan.';
                message.error(app.errorMessage, 5);
              } else {
                app.votingSystem = data.room_setting.voting_system;
                app.votingSystem.push('☕');
                app.user_results.forEach((result) => {
                  app.players.forEach((player) => {
                    if (player.id.toString() === result.user_id.toString()) {
                      player.result = result.result;
                    }
                  });
                });
                app.selectedCard = data.user_result;
              }
            } else {
              app.errorMessage = response.data.message;
              message.error(response.data.message);
            }

            //console.log("Init user result: " + app.selectedCard);
          })
          .catch((error) => {
            app.gameLoading = false;
            //console.log(error);
          });
    },
    selectNumberByItem(item, shouldUpdate = true) {
      this.selectedCard = this.selectedCard === item ? null : item.toString();
      //console.log("User selected " + this.selectedCard);
      if (shouldUpdate) {
        this.assignResult();
      }
    },
    resetUserSelectedNumber() {
      this.selectedCard = null;
    },
    userTransFormer(pusherUser) {
      return {
        id: pusherUser.original.id,
        name: pusherUser.original.name,
        avatar: pusherUser.original.avatar_url,
        photo: pusherUser.original.photo,
      };
    },
    showResult() {
      this.gameLoading = true;
      let app = this;
      axios
          .post(route("planning-rooms.showResult", {id: app.roomId}))
          .then((response) => {
            // app.timerCount = 0;
            if (!response.data.success) {
              app.gameLoading = false;
              message.error(response.data.message, 10);
            }
          })
          .catch((error) => {
            app.gameLoading = false;
            // message.error(error);
            console.log(error);
          });
    },
    getResult() {
      let app = this;
      axios
          .post(route("planning-rooms.getResult", {id: app.roomId}))
          .then((response) => {
            // app.timerCount = 0;
            if (!response.data.success) {
              app.gameLoading = false;
              message.error(response.data.message, 10);
            } else {
              response.data.data.user_results.forEach((result) => {
                app.players.forEach((player) => {
                  if (player.id.toString() === result.user_id.toString()) {
                    player.result = result.result;
                  }
                });
              });
              app.votingSystem = response.data.room_data.voting_system;
              app.votingSystem.push('☕');
              app.roomName = response.data.room_data.name;
              app.play_count = response.data.room_data.play_count;
              app.play_max_count = response.data.room_data.play_max_count;
              app.is_room_subscribed = response.data.room_data.is_room_subscribed;
              app.summary = response.data.data.summary;
              app.roomStateFinished = true;
              app.gameLoading = false;
              app.shuffle();
            }
          })
          .catch((error) => {
            app.gameLoading = false;
            // message.error(error);
            console.log(error);
          });
    },
    shuffle: function () {
      this.players = this.players.sort((a, b) => b.result - a.result);
    },
    startNewGame() {
      this.roomStateFinished = false;
      this.user_results = [];
      this.resetPlayesResult();
      this.resetUserSelectedNumber();
      this.gameLoading = false;
    },
    resetPlayesResult() {
      this.players.forEach((player) => (player.result = null));
    },
    info(roomKey) {
      let testingCodeToCopy = document.querySelector("#room" + roomKey);
      testingCodeToCopy.setAttribute("type", "text"); // 不是 hidden 才能複製
      testingCodeToCopy.select();

      try {
        document.execCommand("copy");
        message.success("Your link is copied");
      } catch (err) {
        message.error("Oops, unable to copy");
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
    announceResult() {
      this.gameLoading = true;
      let app = this;
      axios
          .post(route("planning-rooms.broadcast", {id: app.roomId}), {
            event: "show_result",
          })
          .then((response) => {
            //console.log(response.data);
          })
          .catch((error) => {
            //console.log(error);
          });
    },
    updatedRoom(value) {
      if (value) {
        this.showEditModal = false;
      }
    },
    touredDone() {
      window.localStorage.setItem('toured', 1);
    },
    updatingRoom() {

    },
    getLink(id) {
      return this.$page.props.env !== 'production' ? 'https://staging.agilesuite.io/rooms/' + id : 'https://agilesuite.io/rooms/' + id;
    },
    announceNewGame() {
      this.gameLoading = true;
      let app = this;
      axios
          .post(route("planning-rooms.broadcast", {id: app.roomId}), {
            event: "new_game",
          })
          .then((response) => {
          })
          .catch((error) => {
            //console.log(error);
          });
    },
    restart() {
      if (confirm("Are you sure you want to restart?")) {
        this.announceNewGame();
      }
    },
  },
};
</script>

<style>
.flip-list-move {
  transition: transform 1s;
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}

.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
</style>
